<div id="global-loader">
    <img src="./assets/images/loader.svg" class="loader-img" alt="Loader" />
</div>
<div class="page main-signin-wrapper">
    <section class="signup__area po-rel-z1 pt-100 pb-145">
        <div class="container shapes-div">
            <div class="row">
                <div class="sign__shape">
                    <img src="assets/images/man-1.png" alt="" class="man-1" />
                    <img src="assets/images/man-2.png" alt="" class="man-2" />
                    <img src="assets/images/circle.png" alt="" class="circle" />
                    <img src="assets/images/zigzag.png" alt="" class="zigzag" />
                    <img src="assets/images/dot.png" alt="" class="dot" />
                    <img src="assets/images/sign-up.png" alt="" class="bg" />
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-xl-8 offset-xl-2">
                    <div class="section__title-wrapper text-center mb-5">
                        <h2 class="section__title mb-1">Sign Up</h2>
                        <p>If You Don't Have An Account You Can Register Here!</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-8 offset-xl-2 col-lg-8 offset-lg-2">
                    <div class="sign__wrapper sign__wrapper1 white-bg">
                        <div class="sign__header mb-4">
                            <div class="sign__in text-center">
                                <h2>Student Registration</h2>
                                <!-- <ul class="social-media-icons">
                                    <li>
                                        <a href="#" class="sign__social ml-2">
                                            <i class="fa fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" class="sign__social ml-2">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" class="sign__social ml-2">
                                            <i class="fa fa-youtube"></i>
                                        </a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                        <div class="sign__form">
                            <form [formGroup]="registrationForm" novalidate>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <h6>First Name
                                            <span>*</span></h6>
                                        <div class="input-group mb-3 sign__input">
                                            <input required type="text" class="form-control mrb b"
                                                formControlName="StuFirstName" maxlength="50" placeholder="First Name"
                                                aria-label="Student's Email ID" aria-describedby="basic-addon2">
                                            <!-- <span class="validation-error" *ngIf="(formSubmitted || registrationForm.controls.StuFirstName.touched) 
                                            && registrationForm.controls.naStuFirstNameme.errors?.required">Name is required</span> -->
                                        </div>
                                        <mat-error class="margin_tp"
                                            *ngIf="registrationForm.controls['StuFirstName'].touched && registrationForm.controls['StuFirstName'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                        <mat-error class="margin_tp"
                                        *ngIf="registrationForm.controls['StuFirstName'].touched && registrationForm.controls['StuFirstName'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                    </div>
                                    <div class="col-sm-4">
                                        <h6>Middle Name
                                            <span>*</span></h6>
                                        <div class="input-group mb-3 sign__input">
                                            <input required type="text" class="form-control mrb b"
                                                formControlName="StuMidName" maxlength="50" placeholder="Middle Name"
                                                aria-label="Student's Email ID" aria-describedby="basic-addon2">
                                            <!-- <span class="validation-error" *ngIf="(formSubmitted || registrationForm.controls.StuFirstName.touched) 
                                            && registrationForm.controls.naStuFirstNameme.errors?.required">Name is required</span> -->
                                        </div>
                                        <mat-error class="margin_tp"
                                            *ngIf="registrationForm.controls['StuMidName'].touched && registrationForm.controls['StuMidName'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="registrationForm.controls['StuMidName'].touched && registrationForm.controls['StuMidName'].errors?.pattern">
                                          Invalid
                                        </mat-error>
                                    </div>
                                    <div class="col-sm-4">
                                        <h6>Last Name
                                            <span>*</span></h6>
                                        <div class="input-group mb-3 sign__input">
                                            <input type="text" class="form-control mrb b" formControlName="StuLastName"
                                                maxlength="50" placeholder="Last Name" aria-label="Student's Email ID"
                                                aria-describedby="basic-addon2">
                                            <!-- <span class="validation-error" *ngIf="(formSubmitted || registrationForm.controls.StuFirstName.touched) 
                                            && registrationForm.controls.naStuFirstNameme.errors?.required">Name is required</span> -->
                                           
                                        </div>
                                        <mat-error class="margin_tp"
                                        *ngIf="registrationForm.controls['StuLastName'].touched && registrationForm.controls['StuLastName'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="registrationForm.controls['StuLastName'].touched && registrationForm.controls['StuLastName'].errors?.pattern">
                                       Invalid
                                    </mat-error>
                                    </div>
                                    <div class="col-sm-6">
                                        <h6 class="mt-3">Email ID
                                            <span>*</span></h6>
                                        <div class="input-group  sign__input">
                                            <input type="text" required class="form-control marg mrb b" [readOnly]="isEmailDisabled"
                                             formControlName="StuEmailId" placeholder="Email ID"  (input)="emailvali($event.target.value)"
                                                aria-label="Student's Email ID" aria-describedby="basic-addon2">
                                            <!-- <div *ngIf="bfrsendotpmail" class="input-group-append"  (click)="SendEmail()">
                                                <span   class="input-group-text a e-btn w-100 colfff btnHight"
                                                    id="basic-addon2">Send OTP
                                                </span>
                                            </div> -->
                                            <div *ngIf="resendotp" [class.disabled-div]="isDivDisabled"  class="input-group-append"  (click)="resendEmailWithTimeout()">
                                                <span   class="input-group-text a e-btn w-100 colfff btnHight"
                                                    id="basic-addon2">Resend OTP
                                                </span>
                                            </div>
                                            <div *ngIf="send1stotp" [class.disabled-div]="isDivDisabled || !isEmailValid"  class="input-group-append"  (click)="sendEmailWithTimeout()">
                                                <span   class="input-group-text a e-btn w-100 colfff btnHight"
                                                    id="basic-addon2">Send OTP
                                                </span>
                                            </div>
                                            <div *ngIf="isDivDisabled" class="timer red11">{{ remainingTime }}s</div>
                                        </div>
                                        <mat-error  class="margin_tp"
                                        *ngIf="registrationForm.controls['StuEmailId'].touched && registrationForm.controls['StuEmailId'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                    <mat-error  class="margin_tp"
                                        *ngIf="registrationForm.controls['StuEmailId'].touched && registrationForm.controls['StuEmailId'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <!-- <span class="red" *ngIf="showerr">
                                        Invalid
                                    </span> -->
                                    </div>
                                    <div class="col-sm-6">
                                        <h6 class="mt-3">Enter OTP Received On Email
                                            <span>*</span></h6>
                                        <div class="input-group mb-3 sign__input">
                                            <input required type="text" class="form-control mrb b" formControlName="emailOTP"
                                                placeholder="OTP Received On Email"
                                                aria-label="Enter Otp Received On Email"
                                                aria-describedby="basic-addon2">
                                            <div *ngIf="otpverify" class="input-group-append" (click)="verifyEmailOtp()">
                                                <span class="input-group-text btnHight bgcolorrrr a e-btn w-100 colfff"
                                                    id="basic-addon2">Verify OTP</span>
                                                    
                                            </div>
                                            
                                        </div>
                                        <div *ngIf="msgshw" class="greennn text-center">
                                            <p><b> {{messageee}}</b></p>
                                        </div>
                                        <div *ngIf="msgshw2" class="red text-center">
                                            <p><b> {{messageee}}</b></p>
                                        </div>
                                        <mat-error class="margin_tp"
                                        *ngIf="registrationForm.controls['emailOTP'].touched && registrationForm.controls['emailOTP'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    </div>
                                    <div class="col-sm-4">
                                        <h6 class="mt-3">Mobile No.
                                            <span>*</span>
                                        </h6>
                                        <div class="input-group mb-3 sign__input">
                                            <!-- <span class="prefix"><input></span> -->
                                            <input type="text" required class="form-control mrb b" maxlength="10"
                                                formControlName="StuMobNumber" placeholder="Mobile No."
                                                aria-label="Student's Mobile No." aria-describedby="basic-addon2">
                                            <!-- <div class="input-group-append" (click)="SendOtp()">
                                                <span class="input-group-text  a e-btn w-100 btnHight "
                                                    id="basic-addon2">OTP</span>
                                            </div> -->
                                        </div>
                                        <mat-error class="margin_tp marg"
                                        *ngIf="registrationForm.controls['StuMobNumber'].touched && registrationForm.controls['StuMobNumber'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp marg"
                                        *ngIf="registrationForm.controls['StuMobNumber'].touched && registrationForm.controls['StuMobNumber'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                    </div>
                                    <!-- <div class="col-sm-6">
                                        <h6>Enter OTP Received On Mobile No.</h6>
                                        <div class="input-group mb-3 sign__input">
                                            <input type="text" class="form-control b" formControlName="mobOTP"
                                                placeholder="OTP Received On Mobile No."
                                                aria-label="Enter Otp Received On Mobile No."
                                                aria-describedby="basic-addon2">
                                            <div class="input-group-append">
                                                <span class="input-group-text btnHight  a e-btn w-100 colfff"
                                                    id="basic-addon2">Verify OTP</span>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="col-sm-4 sign__input-wrapper mb-3">
                                        <h6 class="mt-3">Password
                                            <span>*</span>
                                        </h6>
                                        <div class="sign__input">
                                            <input maxlength="5" name="password"
                                                [type]="showPassword ? 'text' : 'password'"
                                                class="form-control b" id="password-field"
                                                placeholder="Password" formControlName="StuPassword1">
                                            <!-- <i class="fa fa-lock"></i> -->
                                            <i alt="show" class="fa fa-eye-slash eyeeee"
                                                (click)="showPassword = !showPassword" [class.hide]="showPassword"></i>
                                            <i alt="hide" class="fa fa-eye eyeeee" (click)="showPassword = !showPassword"
                                                [class.hide]="!showPassword"></i>
                                        </div>
                                        <mat-error class="margin_tp"
                                        *ngIf="registrationForm.controls['StuPassword1'].touched && registrationForm.controls['StuPassword1'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    </div>
                                    <div class="col-sm-4 sign__input-wrapper mb-3">
                                        <h6 class="mt-3">
                                            Confirm Password <span>*</span></h6>
                                        <div class="sign__input">
                                            <input maxlength="5" name="password"
                                                [type]="showPassword2 ? 'text' : 'password'"
                                                class="form-control b" id="password-field"
                                                placeholder="Password" formControlName="StuPassword">
                                            <!-- <i class="fa fa-lock"></i> -->
                                            <i alt="show" class="fa fa-eye-slash eyeeee"
                                                (click)="showPassword2 = !showPassword2"
                                                [class.hide]="showPassword2"></i>
                                            <i alt="hide" class="fa fa-eye eyeeee" (click)="showPassword2 = !showPassword2"
                                                [class.hide]="!showPassword2"></i>
                                        </div>
                                        <mat-error class="margin_tp"
                                    *ngIf="registrationForm.controls['StuPassword'].touched && registrationForm.controls['StuPassword'].errors?.required">
                                    Mandatory
                                </mat-error>
                                    </div>
                                    
                                </div>

                                <div class="col-sm-6 sign__action d-sm-flex justify-content-between mb-4">
                                    <!-- <div class="sign__agree d-flex align-items-center">
                                        <input type="checkbox" id="m-agree" class="m-check-input" />
                                        <label for="m-agree" class="m-check-label">Keep me signed in
                                        </label>
                                    </div> -->
                                    <!-- <div class="sign__forgot">
                                        <a>Forgot your password?</a>
                                    </div> -->
                                </div>
                                <div *ngIf="Message">
                                    <div class="red text-center">
                                        <p><b>{{ErrorMsg}}</b></p>
                                    </div>
                                </div>
                                <button *ngIf="btnShow" class="e-btn w-100 colfff col-sm-6 offset-sm-3 mt-1" type="submit"
                                    (click)="register()">Register</button>
                                    <button *ngIf="btnShow2" disabled class="disabled-div e-btn w-100 col-red col-sm-6 offset-sm-3 mt-1" type="submit"
                                    (click)="register()">Register</button>
                                <div class="sign__new text-center mt-3">
                                    <p> <a (click)="SignIn()">Already Registered? Sign In</a></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>